import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { LibraryElementsModule } from '@app/library/library-elements.module';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { AccountService, ContentService } from '@core/services';

import { IconComponent } from '@shared/icon/icon.component';

import { User } from 'lingo2-models';
import { takeUntil } from 'rxjs/operators';
import { AbstractPane } from '../models/abstract-pane';

@Component({
  selector: 'app-statistic-informer',
  templateUrl: './statistic-informer.component.html',
  styleUrls: ['./statistic-informer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, SpinnersModule, RouterModule, LibraryElementsModule, IconComponent],
})
export class StatisticInformerComponent extends AbstractPane implements OnInit {
  private readonly contentService = inject(ContentService);
  private me: User;

  public ngOnInit() {
    this.contextService.me$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (me) => {
        this.me = me;
        this.prepareTitle();
      },
      error: (error) => {
        this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
      },
    });
  }

  public hasContent(): boolean {
    return !!this._pane && !!this._pane.stats;
  }

  public load() {
    // Stats informer
    this.loadStats();
  }

  public prepareTitle() {
    this.blockTitle = this.isTeacher
      ? {
          title: 'statistic-informer.title',
          add_link: '/constructor',
        }
      : {
          title: 'statistic-informer.title-student',
          add_link: '',
        };
  }

  public get isTeacher(): boolean {
    return AccountService.isAsIfTeacher(this.me);
  }

  protected onContentLoaded(viaQuery?: boolean): void {
    this.isVisible = true;
  }

  private loadStats() {
    if (!this._pane.loaded) {
      this._pane.loading = true;
      this.contentService
        .getStats()
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: (stats) => {
            this._pane.stats = stats;
            this.loadDataFinished(true);
          },
          error: (error) => {
            this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
          },
        });
    } else {
      this.loadDataFinished(false);
    }
  }
}
